import React from "react";
import { SpinnerCircularFixed } from "spinners-react";

const Spinner = () => {
  return (
    <div
      style={{
        minHeight: "80vh", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SpinnerCircularFixed
        size={74}
        thickness={100}
        speed={100}
        color="#3B82F6" 
        secondaryColor="rgba(0, 0, 0, 0.1)"
      />
    </div>
  );
};

export default Spinner;
